<template>
  <div>
    <h1 class="mt-5">Biztosítás adatai</h1>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Csatlakozási nyilatkozat száma:</label>
      <div class="col-sm-8">
        {{ product_code }}
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Milyen sportra kíván biztosítást kötni:</label>
      <div class="col-sm-8">
        {{ sportNames[chosenSport] }}
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Milyen csomagot választott:</label>
      <div class="col-sm-8">{{ packageName }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Baleseti halál:</label>
      <div class="col-sm-8">
        {{ limitek[sportok[chosenSport]][chosenPackage].limit.halal | currency }}
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Temetési költség:</label>
      <div class="col-sm-8">
        {{ limitek[sportok[chosenSport]][chosenPackage].limit.temetes | currency }}
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Baleseti maradandó rokkantság (1-100%):</label>
      <div class="col-sm-8">
        {{ limitek[sportok[chosenSport]][chosenPackage].limit.rokkantsag | currency }}
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Átképzési költség:</label>
      <div class="col-sm-8">
        {{ limitek[sportok[chosenSport]][chosenPackage].limit.atkepzes | currency }}
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Kerekesszék térítés:</label>
      <div class="col-sm-8">
        {{ limitek[sportok[chosenSport]][chosenPackage].limit.kerekesszek | currency }}
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Kórházi műtéti szolgáltatás baleset esetén (1-100%):</label>
      <div class="col-sm-8">
        {{ limitek[sportok[chosenSport]][chosenPackage].limit.mutet | currency }}
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Kórházi napi térítés baleset esetén (1-30 napig):</label>
      <div class="col-sm-8">
        {{ limitek[sportok[chosenSport]][chosenPackage].limit.napiterites | currency }}
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Baleseti eredetű csonttörés (egyösszegű):</label>
      <div class="col-sm-8">
        {{ limitek[sportok[chosenSport]][chosenPackage].limit.csonttores | currency }}
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">
        Ideiglenes teljes keresőképtelenség baleset esetén (egyösszegű térítés, legalább 46 nap
        keresőképtelenség esetén)</label
      >
      <div class="col-sm-8">
        {{ limitek[sportok[chosenSport]][chosenPackage].limit.keresokeptelenseg | currency }}
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4"> Éves biztosítási díj:</label>
      <div class="col-sm-8">
        {{ limitek[sportok[chosenSport]][chosenPackage].dij | currency }}
      </div>
    </div>

    <!-- <div v-if="contractFor !== 3">
      <div class="form-group row mb-5">
        <label class="col-sm-4">Az ingatlan irányítószáma:</label>
        <div class="col-sm-8">{{ propertyZip }}</div>
      </div>
      <h1>Főépület adatai</h1>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Mekkora az épület/ingatlan hasznos alapterülete?</label>
        <div class="col-sm-8">{{ insurancePropertyFloor }} m2</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Az Ön által választott biztosítási összeg:</label>
        <div class="col-sm-8">{{ insurancePropertyInsurance | currency }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Az ingatlan építési éve:</label>
        <div class="col-sm-8">{{ insurancePropertyBuiltYear }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Életvitelszerűen tartozkodó lakók</label>
        <div class="col-sm-8">{{ insurancePropertyResidents }} fő</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Ingatlan falazata</label>
        <div class="col-sm-8">{{ stringPropertyWall(insurancePropertyWall) }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Ingatlan tetőzete</label>
        <div class="col-sm-8">{{ stringPropertyRoof(insurancePropertyRoof) }}</div>
      </div>
      <div v-if="sideBuildings.length > 0" class="mt-5">
        <h1>Melléképületek adatai</h1>
        <div v-for="(building, key) in sideBuildings" :key="key" class="mb-2">
          <h2 v-if="sideBuildings.length > 1">{{ key + 1 }}. melléképület adatai</h2>
          <div class="form-group row mb-2">
            <label class="col-sm-4">Melléképület alapterülete</label>
            <div class="col-sm-8">{{ building.floorArea }} m2</div>
          </div>
          <div class="form-group row mb-2">
            <label class="col-sm-4">Melléképület falazata</label>
            <div class="col-sm-8">{{ stringPropertyWall(building.wallType) }}</div>
          </div>
          <div class="form-group row">
            <label class="col-sm-4">Melléképület tetőzete</label>
            <div class="col-sm-8">{{ stringPropertyRoof(building.roofType) }}</div>
          </div>
        </div>
        <hr />
        <div class="form-group row">
          <label class="col-sm-4">Választott biztosítási összeg</label>
          <div class="col-sm-8">{{ sideBuildingsInsurance | currency }}</div>
        </div>
      </div>
    </div> -->
    <!-- <div v-if="contractFor !== 2" class="mt-5">
      <h1>Ingóságok</h1>
      <div class="form-group row mb-2" v-if="acceptCalculatedInsurance">
        <label class="col-sm-4">Ajánlott biztosított ingóság ár</label>
        <div class="col-sm-8">{{ calculatedInsurancePrice | currency }}</div>
      </div>
      <div class="form-group row mb-2" v-if="!acceptCalculatedInsurance">
        <label class="col-sm-4">Megadott biztosított ingóság ár</label>
        <div class="col-sm-8">{{ allGoodsPrice | currency }}</div>
      </div>
    </div> -->
    <!-- <h1 class="mt-5">Egyéb</h1>
    <div class="form-group row mb-2">
      <label class="col-sm-4">A szerződő magánszemély?</label>
      <div class="col-sm-8">{{ privatePerson ? 'Igen' : 'Nem' }}</div>
    </div> -->
    <!-- <h1 class="mt-5">Kiegészítők</h1>
    <div class="mb-4" v-if="Object.keys(chosenAccesories).length <= 0">
      Ön nem választott ki egyetlen kiegészítőt sem.
    </div>
    <div class="row p-3 mb-4" v-else>
      <div class="col-12 mb-3" v-for="(accesory, key) in chosenAccesories" :key="key">
        <Accesory :accesory="accesory" :aKey="key" :selectable="false" />
      </div>
    </div> -->
    <!-- <h1>Díjfizetés</h1> -->
    <div class="form-group row">
      <label class="col-sm-4">Kockázatviselés kezdete:</label>
      <div class="col-sm-8">{{ new Date(riskStartDate).toLocaleDateString('hu-HU') }}</div>
    </div>
    <!-- <div class="form-group row mb-2">
      <label class="col-sm-4">A biztosítás éves díj:</label>
      <div class="col-sm-8">
        {{ $store.state.chooseableAccesories.accessorySumPrice | currency }}
      </div>
    </div> -->
    <!-- <div class="form-group row mb-2">
      <label class="col-sm-4">A kiegészítők díja összesen:</label>
      <div class="col-sm-8">{{ $store.state.eves_dij_plus | currency }}</div>
    </div> -->
    <!-- <div class="form-group row mb-2">
      <label class="col-sm-4">A biztosítás éves díja összesen:</label>
      <div class="col-sm-8">{{ $store.state.kieg_emelt_eves_dij | currency }}</div>
    </div> -->

    <div class="form-group row mb-2">
      <label class="col-sm-4">Díjfizetés módja:</label>
      <div class="col-sm-8">{{ stringPaymentType }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Díjfizetés gyakorisága:</label>
      <div class="col-sm-8">{{ stringPaymentFrequency }}</div>
    </div>
    <!-- <div class="form-group row mb-2">
      <label class="col-sm-4">Elektronikus kommunikáció</label>
      <div class="col-sm-8">{{ electronicContact ? 'Igen' : 'Nem' }}</div>
    </div> -->
    <!-- <div class="form-group row">
      <label class="col-sm-4">Elektronikus kárrendezés</label>
      <div class="col-sm-8">{{ electronicInsuring ? 'Igen' : 'Nem' }}</div>
    </div> -->
    <h1 class="mt-5">Személyes adatok</h1>
    <h2 class="mt-4">Biztosított adatai</h2>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Biztosított vezetékneve:</label>
      <div class="col-sm-8">{{ insuredLastName }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Biztosított keresztneve:</label>
      <div class="col-sm-8">{{ insuredFirstName }}</div>
    </div>
    <!-- <div class="form-group row mb-2">
      <label class="col-sm-4">Biztosított születéskori neve:</label>
      <div class="col-sm-8">{{ insuredBornName }}</div>
    </div> -->
    <div class="form-group row mb-2">
      <label class="col-sm-4">Biztosított anyja leánykori neve:</label>
      <div class="col-sm-8">
        {{ insuredMotherChildName }}
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Biztosított születési helye:</label>
      <div class="col-sm-8">{{ insuredBornCity }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Biztosított születési dátuma:</label>
      <div class="col-sm-8">
        {{ new Date(insuredBornDate).toLocaleDateString('hu-HU') }}
      </div>
    </div>
    <div v-if="nsuMiner" class="form-group row mb-2">
      <label class="col-sm-4">Biztosított email címe:</label>
      <div class="col-sm-8">{{ insuredEmail ? insuredEmail : contractEmail }}</div>
    </div>
    <div v-if="nsuMiner" class="form-group row">
      <label class="col-sm-4">Biztosított telefonszáma:</label>
      <div class="col-sm-8">
        +36 {{ insuredPhoneNumberArea }}
        {{ insuredPhoneNumber }}
      </div>
    </div>
    <div v-if="nsuMiner">
      <h2 class="mt-4">Biztosított címe</h2>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Irányítószám:</label>
        <div class="col-sm-8">{{ locationZip }}</div>
      </div>
      <div class="form-group row mb-2">
        <label for="" class="col-sm-4">Település neve:</label>
        <div
          class="col-sm-8"
          v-if="typeof locationCity === 'object' && locationCity && locationCity.length > 0"
        >
          {{ locationCity }}
        </div>
        <div class="col-sm-8" v-else>{{ locationCity }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Közterület neve:</label>
        <div class="col-sm-8">{{ locationName }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Közterület jellege:</label>
        <div class="col-sm-8">{{ locationType }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Házszám:</label>
        <div class="col-sm-8">{{ locationHouseNumber }}</div>
      </div>
      <div class="form-group row mb-2" v-if="locationBuilding !== ''">
        <label class="col-sm-4">Épület, lépcsőház, emelet, ajtó:</label>
        <div class="col-sm-8">{{ locationBuilding }}</div>
      </div>
      <!-- <div class="form-group row" v-if="contractLocationTopography !== ''">
        <label class="col-sm-4">Helyrajzi szám:</label>
        <div class="col-sm-8">{{ contractLocationTopography }}</div>
      </div> -->
    </div>
    <div v-if="!contractedIsInsured && !nsuMiner">
      <h2 class="mt-4">{{ contractorNameText }} adatai</h2>
      <div v-if="privatePerson">
        <div class="form-group row mb-2">
          <label class="col-sm-4">{{ contractorNameText }} vezetékneve:</label>
          <div class="col-sm-8">{{ contractedIsInsured ? insuredLastName : contractLastName }}</div>
        </div>
        <div class="form-group row mb-2">
          <label class="col-sm-4">{{ contractorNameText }} keresztneve:</label>
          <div class="col-sm-8">
            {{ contractedIsInsured ? insuredFirstName : contractFirstName }}
          </div>
        </div>
        <!-- <div class="form-group row mb-2">
          <label class="col-sm-4">{{ contractorNameText }} születéskori neve:</label>
          <div class="col-sm-8">{{
            contractedIsInsured ? insuredBornName : contractBornName
          }}</div>
        </div>
        <div class="form-group row mb-2">
          <label class="col-sm-4">{{ contractorNameText }} anyja leánykori neve:</label>
          <div class="col-sm-8">
            {{ contractedIsInsured ? insuredMotherChildName : contractMotherChildName }}
          </div>
        </div>
        <div class="form-group row mb-2">
          <label class="col-sm-4">{{ contractorNameText }} születési helye:</label>
          <div class="col-sm-8">{{
            contractedIsInsured ? insuredBornCity : contractBornCity
          }}</div>
        </div>
        <div class="form-group row mb-2">
          <label class="col-sm-4">{{ contractorNameText }} születési dátuma:</label>
          <div class="col-sm-8">
            {{
              new Date(
                contractedIsInsured ? insuredBornDate : contractBornDate
              ).toLocaleDateString('hu-HU')
            }}
          </div>
        </div>
      </div>
      <div v-else>
        <div class="form-group row mb-2">
          <label class="col-sm-4">{{ contractorNameText }} neve:</label>
          <div class="col-sm-8">{{ contractorCompanyName }}</div>
        </div>

        <div class="form-group row mb-2">
          <label class="col-sm-4">{{ contractorNameText }} adószáma:</label>
          <div class="col-sm-8">{{ contractorVat }}</div>
        </div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">{{ contractorNameText }} email címe:</label>
        <div class="col-sm-8">{{
          contractedIsInsured ? insuredEmail : contractEmail
        }}</div>
      </div>
      <div class="form-group row">
        <label class="col-sm-4">{{ contractorNameText }} telefonszáma:</label>
        <div class="col-sm-8">
          +36 {{ contractedIsInsured ? insuredPhoneNumberArea : contractPhoneNumberArea }}
          {{ contractedIsInsured ? insuredPhoneNumber : contractPhoneNumber }}
        </div>
      </div>
      <div v-if="!contractedIsInsured">
        <h2 v-if="!privatePerson && !contractedIsInsured" class="mt-4">Székhely címe</h2>
        <h2 v-else class="mt-4">{{ contractorNameText }} címe</h2>
        <div class="form-group row mb-2">
          <label class="col-sm-4">Irányítószám:</label>
          <div class="col-sm-8">{{ companyLocationZip }}</div>
        </div>
        <div class="form-group row mb-2">
          <label class="col-sm-4">Település neve:</label>
          <div
            class="col-sm-8"
            v-if="
              typeof companyLocationCity === 'object' &&
                companyLocationCity &&
                companyLocationCity.length > 0
            "
          >
            {{ companyLocationCity }}
          </div>
          <div class="col-sm-8" v-else>{{ companyLocationCity }}</div>
        </div>
        <div class="form-group row mb-2">
          <label class="col-sm-4">Közterület neve:</label>
          <div class="col-sm-8">{{ companyLocationName }}</div>
        </div>
        <div class="form-group row mb-2">
          <label class="col-sm-4">Közterület jellege:</label>
          <div class="col-sm-8">{{ companyLocationType }}</div>
        </div>
        <div class="form-group row mb-2">
          <label class="col-sm-4">Házszám:</label>
          <div class="col-sm-8">{{ companyLocationHouseNumber }}</div>
        </div>
        <div class="form-group row mb-2" v-if="companyLocationBuilding !== ''">
          <label class="col-sm-4">Épület, lépcsőház, emelet, ajtó:</label>
          <div class="col-sm-8">{{ companyLocationBuilding }}</div>
        </div>
         <div class="form-group row" v-if="contractLocationTopography !== ''">
        <label class="col-sm-4">Helyrajzi szám:</label>
        <div class="col-sm-8">{{ contractLocationTopography }}</div>
      </div> -->
      </div>
    </div>
    <div v-if="!contractPostAddressIsTheSame">
      <h2 class="mt-4">Levelezési cím</h2>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Irányítószám:</label>
        <div class="col-sm-8">{{ contractLocationZip }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Település neve:</label>
        <div
          class="col-sm-8"
          v-if="
            typeof contractLocationCity === 'object' &&
              contractLocationCity &&
              contractLocationCity.length > 0
          "
        >
          {{ contractLocationCity }}
        </div>
        <div class="col-sm-8" v-else>{{ contractSelectedLocationName }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Közterület neve:</label>
        <div class="col-sm-8">{{ contractLocationName }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Közterület jellege:</label>
        <div class="col-sm-8">{{ contractLocationType }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Házszám:</label>
        <div class="col-sm-8">{{ contractLocationHouseNumber }}</div>
      </div>
      <div class="form-group row mb-2" v-if="contractLocationBuilding !== ''">
        <label class="col-sm-4">Épület, lépcsőház, emelet, ajtó:</label>
        <div class="col-sm-8">{{ contractLocationBuilding }}</div>
      </div>
      <div class="form-group row" v-if="contractLocationTopography !== ''">
        <label class="col-sm-4">Helyrajzi szám:</label>
        <div class="col-sm-8">{{ contractLocationTopography }}</div>
      </div>
    </div>
    <h1 class="h2 mt-4" v-if="!$store.state.dm">E-mail megerősítés</h1>
    <div class="form-group row mb-2" v-if="!$store.state.dm">
      <label class="col-sm-4" for="email_validation_code"
        >E-mailben kapott kód:<span class="text-danger">*</span>
        <button
          class="info border border-white"
          id="validacios_kod-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
          type="button"
        >
          ?
        </button></label
      >
      <ValidationProvider
        rules="required|email_verify_code"
        v-slot="{errors, classes}"
        class="col-sm-4"
      >
        <input
          type="text"
          class="form-control dark-border"
          id="email_validation_code"
          name="email_validation_code"
          v-model="emailVerifyToken"
          :disabled="emailVerified"
          :class="{'is-valid': emailVerified, classes}"
        />
        <small id="email_validation_code-error" class="text-danger input-alert">{{
          errors[0]
        }}</small>
      </ValidationProvider>
    </div>
    <h1 class="h2 mt-4">Nyilatkozatok</h1>
    <div class="form-group">
      <div class="form-check mb-4">
        <ValidationProvider
          name="biztositasi_feltetelek"
          rules="required_checkbox"
          :immediate="true"
        >
          <input
            type="checkbox"
            class="form-check-input"
            id="biztositasi_feltetelek"
            name="nyilatkozatok[]"
            value="biztositasi_feltetelek"
            v-model="electronicCommunation"
          />
        </ValidationProvider>
        <label for="biztositasi_feltetelek" class="form-check-label">
          <span class="text-danger">*</span>&nbsp;
          <b
            >Biztosítási szabályzat és Biztosítási termékismertető elfogadása
            <!-- <button
              type="button" title="Részletek lenyitása"
              :class="insuranceTermsOpened ? 'arrow-up' : 'arrow-down'"
              @click="insuranceTermsClick"
            ></button> -->
            <button
              aria-label="szabalyzat-text-expand"
              @click="insuranceTermsClick"
              type="button"
              :class="insuranceTermsOpened ? 'arrow-up' : 'arrow-down'"
            >
              <img
                v-if="insuranceTermsOpened"
                src="../assets/arrow-up-square-fill.svg"
                alt="Bootstrap"
                width="28"
                height="28"
                name="arrow_up"
              />
              <img
                v-else
                src="../assets/arrow-down-square-fill.svg"
                alt="Bootstrap"
                width="28"
                height="28"
                name="arrow_down"
              />
            </button> </b
          ><br />
          <div v-show="insuranceTermsOpened">
            Kijelentem, hogy megismertem és elfogadom a Colonnade Sportbaleset-biztosítás
            Biztosítási Feltételeit és Ügyféltájékoztatóját, illetve a Biztosítási
            termékismertetőjét.
            <iframe
              title="Biztosítási feltételek"
              aria-label="Biztosítási feltételek"
              class="w-100 mt-2 iframe-border"
              style="height: 500px;"
              src="https://www.colonnade.hu/media/sportintezet-csoportos-colonnade-sportbaleset-biztositas"
              frameborder="1"
            ></iframe>
          </div>
        </label>
      </div>
      <div class="form-check mb-4">
        <ValidationProvider
          name="adatvedelmi_nyilatkozat"
          rules="required_checkbox"
          :immediate="true"
        >
          <input
            type="checkbox"
            class="form-check-input"
            id="adatvedelmi_nyilatkozat"
            name="nyilatkozatok[]"
            value="adatvedelmi_nyilatkozat"
            v-model="privacyProtection"
          />
        </ValidationProvider>
        <label for="adatvedelmi_nyilatkozat" class="form-check-label">
          <b>Adatvédelmi nyilatkozik</b><br />
          <span class="text-danger">*</span>&nbsp; Kijelentem, hogy megismertem és elfogadom a
          biztosítási feltételek részét képező Adatvédelmi Szabályzatban leírtakat, amely alapján a
          Biztosító személyes adataimat gyűjti és kezeli. Amennyiben más személyek személyes adatait
          adtam meg/fogom megadni a Biztosítónak, az érintetteket tájékoztattam az adatvédelmi
          szabályzat tartalmáról, illetve fel vagyok hatalmazva az érintett személyek személyes
          adatainak továbbítására. A Biztosító adatvédelmi szabályzata itt elérhető:
          <a
            href="https://www.colonnade.hu/media/qb-colonnade-adatkezelesi-tajekoztato.pdf"
            target="_blank"
            >itt</a
          >
          elérhető.
        </label>
      </div>
      <div class="form-check mb-4">
        <input
          type="checkbox"
          class="form-check-input"
          id="hirlevel"
          name="nyilatkozatok[]"
          value="hirlevel"
          v-model="marketingMails"
        />
        <label for="hirlevel" class="form-check-label">
          <b>Marketing hozzájárulás</b><br />
          Hozzájárulok, hogy a Colonnade Insurance S.A. postai úton, e-mailben, telefonon, SMS-ben
          vagy egyéb elektronikus úton (üzenetküldő alkalmazások, személyes üzenetek, amelyek
          közösségi médián vagy más, személyre szabott fiókokkal ellátott platformokon keresztül
          érkeznek stb.) a termékeiről és szolgáltatásairól szóló ajánlatokat, hirdetési anyagokat
          vagy más, a Biztosító újdonságairól, tevékenységéről szóló információkat küldjön számomra.
          Továbbá hozzájárulok, hogy a Colonnade Insurance S.A. személyes adataimat közvetlen
          marketing célokra az Adatvédelmi Szabályzatában
          (https://www.colonnade.hu/media/qb-colonnade-adatkezelesi-tajekoztato.pdf) foglaltaknak
          megfelelően feldolgozza. Hozzájárulását az info@colonnade.hu címre küldött emailben
          bármikor visszavonhatja.
        </label>
      </div>
      <div class="form-check mb-4">
        <ValidationProvider
          name="adatkezelesi_nyilatkozat"
          rules="required_checkbox"
          :immediate="true"
        >
          <input
            type="checkbox"
            class="form-check-input"
            id="adatkezelesi_nyilatkozat"
            name="nyilatkozatok[]"
            value="adatkezelesi_nyilatkozat"
            v-model="privacyStatement"
          />
        </ValidationProvider>
        <label for="adatkezelesi_nyilatkozat" class="form-check-label">
          <b>Adatkezelési tájékoztató</b><br />
          <span class="text-danger">*</span>&nbsp; Tudomásul veszem, hogy a Colonnade Insurance S.A.
          Magyarországi Fióktelepe (székhely: 1134 Budapest, Váci út 23-27.) adatkezelő által a
          <a href="https://colonnade.nopa.hu" target="_blank">https://colonnade.nopa.hu</a>
          felhasználói adatbázisában tárolt személyes adataim átadásra kerülnek az OTP Mobil Kft.,
          mint adatfeldolgozó részére. Amennyiben más személyek személyes adatait adtam meg (vagy
          fogom megadni) a Biztosítónak, kijelentem, hogy az érintett személyeket tájékoztattam az
          adatvédelmi szabályzat tartalmáról, illetve ezen rendelkezéseknek megfelelően fel vagyok
          hatalmazva az érintett személyek személyes adatainak továbbítására a Biztosító részére. A
          Biztosító adatvédelmi szabályzata közvetlenül
          <a href="https://www.colonnade.hu/media/adatkezelesi-tajekoztato.pdf" target="_blank"
            >itt</a
          >
          elérhető.
        </label>
      </div>
      <!-- <div v-if="contractReason === 'atkotes'" class="form-check mb-4">
        <ValidationProvider
          name="atkonyveles_nyilatkozat"
          rules="required_checkbox"
          :immediate="true"
        >
          <input
            type="checkbox"
            class="form-check-input"
            id="atkonyveles_nyilatkozat"
            name="nyilatkozatok[]"
            value="atkonyveles_nyilatkozat"
            v-model="contrctReasonStatement"
          />
        </ValidationProvider>
        <label for="atkonyveles_nyilatkozat" class="form-check-label">
          <span class="text-danger">*</span>&nbsp; Hozzájárulok ahhoz, hogy a jelenlegi
          lakásbiztosítási szerződésemről túlfizetés esetén a díjtöbbletet az új szerződésre a
          Biztosító átkönyvelje, továbbá vállalom, hogy díjtartozás esetén a be nem fizetett díjat
          rendezem.
        </label>
      </div> -->

      <!-- <div class="form-check mb-4">
        <ValidationProvider name="tudomasul_veszem" rules="required_checkbox" :immediate="true">
          <input
            type="checkbox"
            class="form-check-input"
            id="tudomasul_veszem"
            name="nyilatkozatok[]"
            value="tudomasul_veszem"
            v-model="acceptTerms"
          />
        </ValidationProvider>
        <label for="tudomasul_veszem" class="form-check-label">
          <span class="text-danger">*</span>&nbsp;
          <b
            >Biztosításkötéssel kapcsolatos nyilatkozat
            <div
              role="button" title="Részletek lenyitása"
              :class="insuranceBondStatementOpened ? 'arrow-up' : 'arrow-down'"
              @click="insuranceBondStatementClick"
            ></div
          ></b>
          <ul v-show="insuranceBondStatementOpened">
            <b>Tudomásul veszem, hogy:</b>
            <li>
              jelen ajánlat a Biztosító kockázat elbírálásának alapja;
            </li>
            <li>
              a Biztosítónak az ajánlattételtől számítva 15 nap áll rendelkezésére az
              ajánlat elbírálására;
            </li>
            <li>
              a Biztosító a kockázatelbírálás eredményeként az ajánlatot indoklás nélkül
              visszautasíthatja, ebben az esetben a biztosítási szerződés nem jön létre;
            </li>
            <li>
              ha a biztosítási esemény a kockázatelbírálási idő alatt bekövetkezik, a
              Biztosító az ajánlatot csak abban az esetben utasíthatja vissza, ha az
              igényelt biztosítási fedezet jellege vagy a kockázatviselés körülményei
              alapján nyilvánvaló, hogy az ajánlat elfogadásához a kockázat egyedi
              elbírálása szükséges;
            </li>
            <li>
              az ajánlattételkor befizetett összeget a Biztosító díjelőlegként kezeli, az
              ajánlat elfogadása esetén pedig díjfizetésnek tekinti, amennyiben a
              Biztosító az ajánlatot elutasítja, a Biztosító a biztosítási díjat a
              szerződőnek kamatmentesen visszautalja;
            </li>
            <li>
              bármely szóbeli közlés vagy kikötés akkor érvényes, ha azokat a Biztosító
              írásban megerősítette;
            </li>
            <li>
              a szerződés létrejöttéről szóló értesítés kézhezvételétől számított 14 napon
              belül indoklás nélkül felmondhatom a biztosítási szerződést;
            </li>
            <li>
              a Biztosító a Colonnade Sportbaleset-biztosítás termékkel kapcsolatosan nem
              nyújt tanácsadást, a termék értékesítése pedig közvetlenül a biztosító
              online értékesítési felületén keresztül történik, az értékesítési
              folyamatban biztosításközvetítő nem működik közre.
            </li>
          </ul>
        </label>
      </div> -->
      <!-- <div class="form-check mb-4" v-if="ertekesito_koti">
        <ValidationProvider name="biztositaskozvetito" rules="required_checkbox" :immediate="true">
          <input
            type="checkbox"
            class="form-check-input"
            id="biztositaskozvetito"
            name="nyilatkozatok[]"
            value="biztositaskozvetito"
            v-model="validMerchant"
          />
        </ValidationProvider>
        <label for="biztositaskozvetito" class="form-check-label">
          <span class="text-danger">*</span>&nbsp;
          <b
            >Amennyiben a biztosítási szerződést független biztosításközvetítő értékesíti, a
            biztosításközvetítő kijelenti, hogy az ügyletre megfelelő alkuszi megbízással
            rendelkezik.</b
          >
        </label>
      </div> -->
      <!-- <div class="form-check mb-4">
        <ValidationProvider name="ptktol_elteres" rules="required_checkbox" :immediate="true">
          <input
            type="checkbox"
            class="form-check-input"
            id="ptktol_elteres"
            name="nyilatkozatok[]"
            value="ptktol_elteres"
            v-model="validDatas"
          />
        </ValidationProvider>
        <label for="ptktol_elteres" class="form-check-label">
          <span class="text-danger">*</span>&nbsp;
          <b
            >Nyilatkozat a szokásostól eltérő szerződési gyakorlat és a Ptk.-tól való
            eltérés elfogadásáról
            <div
              role="button" title="Részletek lenyitása"
              :class="contractPracticeStatementOpened ? 'arrow-up' : 'arrow-down'"
              @click="contractPracticeStatementClick"
            ></div
          ></b>
          <ul class="hyphens" v-show="contractPracticeStatementOpened">
            <b>Kijelentem, hogy:</b
            ><br />
            tájékoztatást kaptam arra vonatkozóan, hogy a Colonnade
            Sportbaleset-biztosítás feltételeinek alábbi rendelkezései lényegesen eltérnek
            a Polgári Törvénykönyvről szóló 2013. évi V. törvény (Ptk.) vonatkozó
            rendelkezéseitől:
            <li>
              A Ptk. 6:22. § (1) bekezdésében foglalt 5 éves elévülési időtől eltérően a
              biztosítási szerződésből eredő igények két év alatt évülnek el.
            </li>
            <li>
              A Ptk. 6:466.§ (1) bekezdésétől eltérően a Szerződő jogosult arra, hogy a
              határozatlan vagy a maximum 1 éves határozott tartamra kötött szerződések
              esetében - a biztosítási évfordulón túl – minden év márciusában – március
              31-ig a Biztosítóhoz beérkezően – költségmentesen a rendes felmondás
              szabályai alapján felmondja a szerződést.
            </li>
            <li>
              A Ptk. 6:470 § (2) bekezdésétől eltérően a biztosító az eljárási költségeket
              nem előlegezi meg.
            </li>
            <li>
              A Ptk. 6:470.§ (3) bekezdésétől eltérően a biztosító a biztosítási összeg
              keretein belül téríti meg a kamatokat és az eljárási költségeket.
            </li>
            <li>
              A Ptk. 6:470.§ (3) bekezdésétől eltérően a biztosító a szerződésben
              megállapított limiten belül, a Szolgáltatási táblában (IV. Záradékok és
              függelékek) meghatározott limit erejéig téríti meg a biztosított
              képviseletét ellátó jogi képviselő – máshonnan meg nem térülő – igazolt
              munkadíját és készkiadásait, illetve a jogi védekezés egyéb költségeit. E
              biztosítási fedezet annyiban áll fenn az ésszerű, indokolt és gazdaságos
              költségek tekintetében, amennyiben azok a biztosítási szerződés fedezete alá
              tartozó, kizáró rendelkezés hatálya alá nem eső és a biztosító részére
              szerződésszerűen bejelentett biztosítási eseménnyel összefüggésben merültek
              fel. A biztosító nem téríti meg ezeket a költségeket, ha a
              szerződő/biztosított maga látja el a jogi védelmét.
            </li>
            <li>
              A Ptk. 6:466.§ (1) bekezdéstől eltérően, amennyiben a biztosító és a külső
              szolgáltató közötti szerződés, valamely okból megszűnik, a biztosítónak joga
              van az Assistance kiegészítő biztosítást az általános felmondási
              szabályoktól eltérő módon, szükség szerint időarányos díjvisszatérítés
              mellett, a külső szolgáltatóval fennállt szerződés megszűnésének időpontjára
              felmondani.
            </li>
            <li>
              A Ptk. 6:470 § (1), illetve (3) bekezdésében foglaltak ellenére a
              biztosítási fedezet nem terjed ki a sérelemdíjra (kivéve a
              felelősségbiztosítás fedezet).
            </li>
            <li>
              A Ptk. 6:63. § (5) bekezdésétől eltérően nem válik a Biztosítási szerződés
              tartalmává a Felek esetleges korábbi szerződéses/üzleti gyakorlata, szokása,
              illetve a biztosítási üzletágban a hasonló jellegű szerződés alanyai által
              széles körben ismert és rendszeresen alkalmazott szokás.
            </li>
            Kijelentem, hogy a Colonnade Édes Otthon Lakásbiztosítás a szokásos szerződési
            gyakorlattól eltérő rendelkezéseit elfogadom, azokat magamra nézve kötelezőnek
            ismerem el.
          </ul>
        </label>
      </div> -->
    </div>
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';
import Accesory from './components/Accesory';
import {parse as parseMoney} from 'vue-currency-input';

export default {
  components: {
    Accesory,
  },
  data() {
    return {
      insuranceTermsOpened: true,
      insuranceBondStatementOpened: false,
      contractPracticeStatementOpened: false,
    };
  },
  computed: {
    ...mapFields([
      'statementSettings.privacyStatement',
      'statementSettings.privacyProtection',
      'statementSettings.insuranceTerms',
      'statementSettings.electronicCommunation',
      'statementSettings.marketingMails',
      'statementSettings.acceptTerms',
      'statementSettings.validMerchant',
      'statementSettings.validDatas',
      'statementSettings.contrctReasonStatement',
      'generalInfo.chosenSport',
      'generalInfo.chosenPackage',
      'generalInfo.privatePerson',
      'generalInfo.contractorVat',
      'generalInfo.propertyZip',
      'generalInfo.propertyName',
      'generalInfo.selectedPropertyName',
      'contractSettings.emailVerified',
      'contractSettings.emailVerifyToken',
      'contractSettings.merchantEmail',
      'riskSettings.companyLocationZip',
      'riskSettings.companyLocationCity',
      'riskSettings.companyLocationName',
      'riskSettings.companyLocationType',
      'riskSettings.companyLocationHouseNumber',
      'riskSettings.companyLocationBuilding',
      'riskSettings.locationZip',
      'riskSettings.locationCity',
      'riskSettings.locationName',
      'riskSettings.locationType',
      'riskSettings.locationHouseNumber',
      'riskSettings.locationBuilding',
      'riskSettings.locationTopography',
      'sportNames',
      'limitek',
      'sportok',
      'merchant_id',
      'product_code',
    ]),
    ...mapFields({
      contractFor: 'generalInfo.contractFor',
      propertyType: 'generalInfo.propertyType',
      propertyOutskirts: 'generalInfo.propertyOutskirts',
      propertyPhysicalJob: 'generalInfo.propertyPhysicalJob',
      propertyOwnRight: 'generalInfo.propertyOwnRight',
      insurancePropertyFloor: 'insuranceProperty.floorArea',
      insurancePropertyInsurance: 'insuranceProperty.chosenInsurancePrice',
      insurancePropertyBuiltYear: 'insuranceProperty.builtYear',
      insurancePropertyResidents: 'insuranceProperty.residents',
      insurancePropertyWall: 'insuranceProperty.wallType',
      insurancePropertyRoof: 'insuranceProperty.roofType',
      sideBuildings: 'insuranceSideBuildings.list',
      sideBuildingsInsurance: 'insuranceSideBuildings.chosenInsurancePrice',

      acceptCalculatedInsurance: 'insurancePersonalGoods.acceptCalculatedInsurance',
      calculatedInsurancePrice: 'insurancePersonalGoods.calculatedInsurancePrice',
      allGoodsPrice: 'insurancePersonalGoods.allGoodsPrice',

      paymentOptionsType: 'paymentOptions.type',
      paymentOptionsFrequency: 'paymentOptions.frequency',
      electronicContact: 'electronicContact',
      electronicInsuring: 'electronicInsuring',

      riskStartDate: 'riskSettings.startDate',
      riskLocationName: 'riskSettings.locationName',
      riskLocationType: 'riskSettings.locationType',
      riskLocationHouseNumber: 'riskSettings.locationHouseNumber',
      riskLocationBuilding: 'riskSettings.locationBuilding',
      riskLocationTopography: 'riskSettings.locationTopography',

      contractorCompanyName: 'contractSettings.companyName',
      contractLastName: 'contractSettings.lastName',
      contractFirstName: 'contractSettings.firstName',
      contractMotherChildName: 'contractSettings.motherChildName',
      contractBornName: 'contractSettings.bornName',
      contractBornCity: 'contractSettings.bornCity',
      contractBornDate: 'contractSettings.bornDate',
      contractEmail: 'contractSettings.email',
      contractPhoneNumberArea: 'contractSettings.phoneNumberArea',
      contractPhoneNumber: 'contractSettings.phoneNumber',
      contractPostAddressIsTheSame: 'contractSettings.postAddressIsTheSame',

      contractLocationZip: 'contractSettings.postAddress.locationZip',
      contractLocationCity: 'contractSettings.postAddress.locationCity',
      contractLocationName: 'contractSettings.postAddress.locationName',
      contractSelectedLocationName: 'contractSettings.postAddress.selectedLocationName',
      contractLocationType: 'contractSettings.postAddress.locationType',
      contractLocationHouseNumber: 'contractSettings.postAddress.locationHouseNumber',
      contractLocationBuilding: 'contractSettings.postAddress.locationBuilding',
      contractLocationTopography: 'contractSettings.postAddress.locationTopography',

      contractedIsInsured: 'insuredSettings.contractedIsInsured',
      insuredLastName: 'insuredSettings.lastName',
      insuredFirstName: 'insuredSettings.firstName',
      insuredMotherChildName: 'insuredSettings.motherChildName',
      insuredBornName: 'insuredSettings.bornName',
      insuredBornCity: 'insuredSettings.bornCity',
      insuredBornDate: 'insuredSettings.bornDate',
      insuredEmail: 'insuredSettings.email',
      insuredPhoneNumberArea: 'insuredSettings.phoneNumberArea',
      insuredPhoneNumber: 'insuredSettings.phoneNumber',

      propertyIsMortgaged: 'mortgageSettings.propertyIsMortgaged',
      mortgageCreditor: 'mortgageSettings.creditor',
      mortgageCreditorLocation: 'mortgageSettings.creditorLocation',
      mortgageId: 'mortgageSettings.mortgageId',
      mortgagePrice: 'mortgageSettings.mortgagePrice',
      mortgageCurrency: 'mortgageSettings.mortgageCurrency',
      mortgageStartDate: 'mortgageSettings.mortgageStartDate',
      mortgageEndDate: 'mortgageSettings.mortgageEndDate',
      ertekesito_koti: 'ertekesito_koti',
      dm: 'dm',
      contractReason: 'kotes_oka',
    }),
    chosenAccesories: function() {
      let accesories = {};

      Object.entries(this.$store.state.chooseableAccesories.selectableList).forEach((accesory) => {
        if (accesory[1]?.selected) accesories[accesory[0]] = accesory[1];
      });

      return accesories;
    },
    stringPropertyType: function() {
      switch (this.propertyType) {
        case 'tarsashaz':
          return 'Társasházi lakás';
        case 'csaladihaz':
          return 'Családi ház';
        case 'sorhaz':
          return 'Sorház';
        case 'ikerhaz':
          return 'Ikerház';
      }
    },
    contractorNameText: function() {
      if (this.merchant_id == 'nsu') return 'Csatlakozási nyilatkozatot tevő';
      else return 'szerződő';
    },
    packageName: function() {
      if (this.chosenPackage == 'alap') return 'Alap csomag';
      else if (this.chosenPackage == 'kozepes') return 'Közepes csomag';
      else return 'Kiemelt csomag';
    },
    stringPropertyOwnType: function() {
      switch (this.propertyOwnRight) {
        case 'sajat':
          return 'Saját tulajdon saját használatban';
        case 'sajat_berbe':
          return 'Saját tulajdon bérbe adva';
        case 'berlemeny':
          return 'Bérlemény';
      }
    },
    stringPaymentType: function() {
      switch (this.paymentOptionsType) {
        case 'csoportos':
          return 'Csoportos beszedési megbízás';
        case 'online':
          return 'Online bankkártyás fizetés';
        case 'atutalas':
          return 'Átutalás';
        case 'csekk':
          return 'Postai csekk';
      }
    },
    stringPaymentFrequency: function() {
      switch (this.paymentOptionsFrequency) {
        case 'eves':
          return 'Éves';
        case 'feleves':
          return 'Féléves';
        case 'negyedeves':
          return 'Negyedéves';
        case 'havi':
          return 'Havi';
      }
    },
    paymentFrequentString() {
      const frequency = this.$store.state.paymentOptions.frequency;
      let stringFrequency;
      if (frequency == 'eves') stringFrequency = ' /év';
      else if (frequency == 'feleves') stringFrequency = ' /félév';
      else if (frequency == 'negyedeves') stringFrequency = ' /negyedév';
      else stringFrequency = ' /hó';
      return (
        this.$options.filters.currency(this.$store.state.gyakorisag_szerint_fizetendo_dij) +
        stringFrequency
      );
    },
    nsuMiner() {
      return !(this.merchant_id === 'nsu' && this.getAge(this.insuredBornDate) < 18);
    },
  },
  methods: {
    insuranceTermsClick(e) {
      if (e) e.preventDefault();
      this.insuranceTermsOpened = !this.insuranceTermsOpened;
    },
    insuranceBondStatementClick(e) {
      if (e) e.preventDefault();
      this.insuranceBondStatementOpened = !this.insuranceBondStatementOpened;
    },
    contractPracticeStatementClick(e) {
      if (e) e.preventDefault();
      this.contractPracticeStatementOpened = !this.contractPracticeStatementOpened;
    },
    stringPropertyWall: function(str) {
      switch (str) {
        case 'tegla':
          return 'Tégla';
        case 'beton':
          return 'Beton';
        case 'ko':
          return 'Kő';
        case 'panel':
          return 'Panel';
        case 'konnyuszerk':
          return 'Könnyűszerkezetes';
        case 'fa':
          return 'Fa';
        case 'valyog':
          return 'Vályog';
        case 'vegyes':
          return 'Vegyes (vályog és szilárd)';
      }
    },
    stringPropertyRoof: function(str) {
      switch (str) {
        case 'cserep':
          return 'Cserép';
        case 'pala':
          return 'Pala';
        case 'nad':
          return 'Nád';
        case 'fazsindely':
          return 'Fazsindely';
        case 'szalma':
          return 'Szalma';
        case 'bitumen':
          return 'Bitumenes';
        case 'muanyag':
          return 'Műanyag';
        case 'fem':
          return 'Fém';
        case 'hullamlemez':
          return 'Bitumenes hullámlemez';
      }
    },
    getAge(birthDate) {
      var today = new Date();
      const birthDateAsDate = new Date(birthDate);
      var age = today.getFullYear() - birthDateAsDate.getFullYear();
      var m = today.getMonth() - birthDateAsDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDateAsDate.getDate())) {
        age--;
      }
      return age;
    },
  },
  watch: {
    emailVerifyToken: function(value) {
      if (btoa(value) == this.$store.state.email_valid_code) {
        this.emailVerified = true;
        this.$store.dispatch('verifyPage', 4).then((res) => {
          this.$store.commit('setNextPageStatus', true);
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$red: #b0001f;

ul.hyphens {
  list-style-type: none;
}

ul.hyphens > li:before {
  content: '–';
  position: absolute;
  margin-left: -1.1em;
}

/*.arrow-up {
  width: 0;
  height: 0;
  background: none;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 4px solid transparent;
  border-bottom: 10px solid $red;
  margin-left: 5px;
  display: inline-block;
  cursor: pointer;
}*/

.arrow-down {
  background-color: transparent;
  border: none;
}

.arrow-up {
  background-color: transparent;
  border: none;
}

/*.arrow-down {
  width: 0;
  height: 0;
  background: none;
  border-bottom: 4px solid transparent;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;

  border-top: 10px solid $red;
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
}*/

.form-check-label {
  margin-top: -20px;
  margin-left: 5px;
}

.iframe-border {
  &:focus {
    outline: 2px #fff solid !important;
    outline-offset: 0 !important;
    box-shadow: 0 0 0 4px #000 !important;
  }
}
</style>
